import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { scrollTop } from '@/helpers/utils';
import { Pagination } from '@/components/Pagination';
import { useWindowSize } from '@/hooks/useWindowSize';
import { setModals } from '@/store/actions/commonActions';
import { MODAL_TYPES } from '@/components/ModalProvider';
import { useGetLoanList } from '@/query/queries/loan/useGetLoanList';
import { Statistics } from '../Statistics';
import { Table } from './table';
import { List } from './list';
import s from './index.module.scss';

export const DataView = () => {
  const [params, setParams] = useState({ page: 1, limit: 10 });
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const { data, isLoading} = useGetLoanList(params);
  const { t } = useTranslation('loans');

  const onLoanOpen = loan => {
    dispatch(
      setModals({
        selectedLoan: loan,
        type: MODAL_TYPES.loan_info,
      }),
    );
  };

  useEffect(() => {
    scrollTop();
  }, [params.page])

  return (
    <div className={s.wrapper}>
      <Statistics data={data} />
      <div className={s.caption}>
        <span className="f-small-regular">{t('claims_breakdown')}</span>
      </div>
      {isMobile ? (
        <List isLoading={isLoading} data={data} onLoanOpen={onLoanOpen} />
      ) : (
        <Table isLoading={isLoading} data={data} onLoanOpen={onLoanOpen} />
      )}
      {data?.total_pages > 0 && (
        <Pagination
          currentPage={params.page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) =>
            setParams(prev => ({ ...prev, page: selected + 1 }))
          }
        />
      )}
    </div>
  );
};
